export const formatToSelect = (array: any[]) => {
  return array.map((item: any) => {
    return {
      value: item.id,
      label: item.name,
    };
  });
};